import React from 'react'
import Giveaway from './component/Giveaway'

const Give = () => {
  return (
    <>
    <Giveaway/>
    </>
  )
}

export default Give